import "bootstrap/dist/css/bootstrap.min.css";
import { useCallback, useEffect, useState } from "react";

const API_BASE_URL = process.env.REACT_APP_API_URL;

const SistemaTransferenciaVerba = () => {
  const [activeTab, setActiveTab] = useState("dashboard");
  /*const [selectedFilial, setSelectedFilial] = useState("");*/

  const [selectedFilial, setSelectedFilial] = useState(
    () => localStorage.getItem("selectedFilial") || ""
  );

  const [searchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [ano] = useState(new Date().getFullYear().toString());

  // Estados para transferência
  const [transferencia, setTransferencia] = useState({
    origemFilial: "",
    destinoFilial: "",
    origemCentroCusto: "",
    destinoCentroCusto: "",
    origemNatureza: "",
    destinoNatureza: "",
    origemIdOrcto: "",
    destinoIdOrcto: "",
    valorTransferido: "",
    motivo: "",
    observacoes: "",
    justificativaDestino: "",
  });

  // Estados de dados
  const [dashboardData, setDashboardData] = useState({
    valorOrcado: 0,
    valorRealizado: 0,
    saldo: 0,
    totalTransferencias: 0,
    totalSolicitacoes: 0,
    aguardandoAprovacao: 0,
    aprovados: 0,
    reprovados: 0,
  });

  const [transferencias, setTransferencias] = useState([]);
  const [transferenciasGlobal, setTransferenciasGlobal] = useState([]);

  const [dadosOrcamentoOrigem, setDadosOrcamentoOrigem] = useState(null);
  const [dadosOrcamentoDestino, setDadosOrcamentoDestino] = useState(null);

  const [centrosCusto, setCentrosCusto] = useState([]);
  const [, setNaturezas] = useState([]);
  const [filiais, setFiliais] = useState([]);

  // ✅ ADICIONAR ESTADO PARA CONTROLAR PERMISSÕES
  const [currentUsername, setCurrentUsername] = useState("");
  const [canApprove, setCanApprove] = useState(false);

  // ✅ FUNÇÃO PARA VERIFICAR PERMISSÕES DE APROVAÇÃO
// ✅ FUNÇÃO PARA VERIFICAR PERMISSÕES DE APROVAÇÃO
const checkApprovalPermissions = () => {
  try {
    const token = localStorage.getItem("authToken");
    if (!token) {
      setCanApprove(false);
      setCurrentUsername("");
      return;
    }

    const tokenPayload = JSON.parse(atob(token.split(".")[1]));
    const username = tokenPayload.username || tokenPayload.id;

    // ✅ LISTA DE USUÁRIOS AUTORIZADOS A APROVAR
    const approvers = ["Gcavallaro", "fnunes", "pandreasi", "aguesse"];
    
    // ❌ REMOVER ESTA LINHA:
    // const isApprover = approvers.includes(currentUser);

    setCurrentUsername(username);
    setCanApprove(approvers.includes(username));

    console.log("🔐 Verificação de permissões:", {
      username,
      canApprove: approvers.includes(username),
      approvers,
    });
  } catch (error) {
    console.error("Erro ao verificar permissões:", error);
    setCanApprove(false);
    setCurrentUsername("");
  }
};

  // 🏢 FUNÇÃO PARA BUSCAR ANOS E FILIAIS DISPONÍVEIS (sql_MAN_ORC_0003)
  const fetchAvailableFiliais = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) return;

      const tokenPayload = JSON.parse(atob(token.split(".")[1]));
      const currentUsername = tokenPayload.username || tokenPayload.id;

      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      // Buscar anos e filiais disponíveis para o usuário usando a SQL correta
      const response = await fetch(
        `${API_BASE_URL}/totvs-sql/sql_MAN_ORC_0003/filter`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({
            WHERE: `AND U.CODUSUARIO = '${currentUsername}'  `, /*and GFILIAL.CODCOLIGADA = '${PCODCOLIGADA}' */
            ORDER_BY: "GFILIAL.NOMEFANTASIA, O.ANO DESC ",
          }),
        }
      );

      const result = await response.json();

      if (result.success && result.data && result.data.length > 0) {
        const allData = result.data.map((item) => ({
          CODFILIAL: item.CODFILIAL,
          NOMEFANTASIA: item.NOMEFANTASIA || `Filial ${item.CODFILIAL}`,
          CODCOLIGADA: item.CODCOLIGADA,
          ANO: item.ANO.toString(),
          CHAVE_UNICA: `${item.CODCOLIGADA}-${item.CODFILIAL}`,
        }));
        setFiliais(allData);
      }
    } catch (error) {
      console.error("Erro ao buscar filiais e anos:", error);
    }
  };

  // ✅ FUNÇÃO PARA OBTER TOKEN E DADOS DO USUÁRIO
  const getAuthData = () => {
    const token = localStorage.getItem("authToken");
    if (!token) throw new Error("Token não encontrado");

    const tokenPayload = JSON.parse(atob(token.split(".")[1]));
    const currentUsername = tokenPayload.username || tokenPayload.id;
    const PCODCOLIGADA = localStorage.getItem("PCODCOLIGADA");
    const PCODFILIAL = localStorage.getItem("PCODFILIAL");

    return {
      token,
      currentUsername,
      PCODCOLIGADA,
      PCODFILIAL,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
  };

  const recarregarDados = async () => {
    try {
      console.log("🔄 Tentando recarregar dados...");

      // Recarregar transferências
      if (typeof carregarTransferencias === "function") {
        console.log("✅ Recarregando transferências...");
        await carregarTransferencias();
        await carregarTransferenciasGlobal();
      }

      // Recarregar dashboard
      if (typeof carregarDashboard === "function") {
        console.log("✅ Recarregando dashboard...");
        await carregarDashboard();
      }

      console.log("✅ Dados recarregados com sucesso");
    } catch (error) {
      console.warn("⚠️ Erro ao recarregar dados:", error);
    }
  };

  // ✅ 2. MODIFICAR A FUNÇÃO carregarDashboard PARA USAR sql_MAN_ORC_0003 QUANDO FILIAL FOR SELECIONADA
  const carregarDashboard = useCallback(async () => {
  try {
    setLoading(true);
    const token = localStorage.getItem("authToken");
    if (!token) return;

    const PCODCOLIGADA = localStorage.getItem("PCODCOLIGADA");
    const PCODFILIAL = localStorage.getItem("PCODFILIAL");
    const selectedYear = localStorage.getItem("selectedYear");

    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    let response;
    let whereClause;

    // ✅ DETERMINAR QUAL ENDPOINT USAR BASEADO EM canApprove
    const approvers = ["Gcavallaro", "fnunes", "pandreasi", "aguesse"];
    const sqlEndpoint = approvers.includes(currentUsername)
      ? "sql_Man_ORC_0011"  // Approvers
      : "sql_Man_ORC_0111"; // Outros usuários
    
    if (selectedFilial && selectedFilial !== "") {
      const [coligadaSelecionada, filialSelecionada] = selectedFilial.split("-");
      whereClause = `AND CODCOLIGADA = '${coligadaSelecionada}' AND CODFILIAL = '${filialSelecionada}' AND ANO = '${selectedYear}' `;

      response = await fetch(
        `${API_BASE_URL}/totvs-sql/${sqlEndpoint}/filter`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({
            WHERE: whereClause,
          }),
        }
      );
    } else {
      whereClause = `AND CODCOLIGADA = '${PCODCOLIGADA}' AND CODFILIAL = '${PCODFILIAL}' AND ANO = '${selectedYear}' `;

      response = await fetch(
        `${API_BASE_URL}/totvs-sql/${sqlEndpoint}/filter`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({
            WHERE: whereClause,
          }),
        }
      );
    }

    const result = await response.json();

    if (result.success && result.data && result.data.length > 0) {
      const data = result.data[0];
      setDashboardData({
        valorOrcado: parseFloat(data.VALOR_ORCADO || 0),
        valorRealizado: parseFloat(data.VALOR_REALIZADO || 0),
        saldo: parseFloat(data.SALDO || 0),
        totalTransferencias: parseInt(data.TOTAL_TRANSFERENCIAS || 0),
        aguardandoAprovacao: parseInt(data.AGUARDANDO_APROVACAO || 0),
        aprovados: parseInt(data.APROVADOS || 0),
        reprovados: parseInt(data.REPROVADOS || 0),
      });
    } else {
      setDashboardData({
        valorOrcado: 0,
        valorRealizado: 0,
        saldo: 0,
        totalTransferencias: 0,
        aguardandoAprovacao: 0,
        aprovados: 0,
        reprovados: 0,
      });
    }
  } catch (error) {
    console.error("Erro ao carregar dashboard:", error);
  } finally {
    setLoading(false);
  }
}, [selectedFilial, currentUsername]);


  // ✅ 3. MODIFICAR AS OUTRAS FUNÇÕES PARA CONSIDERAR A FILIAL SELECIONADA
  const carregarCentrosCusto = useCallback(async () => {
    try {
      const { headers, PCODCOLIGADA, PCODFILIAL, currentUsername } =
        getAuthData();

      // ✅ USAR A FILIAL SELECIONADA OU A FILIAL PADRÃO DO USUÁRIO
      let coligadaFiltro = PCODCOLIGADA;
      let filialFiltro = PCODFILIAL;

      if (selectedFilial && selectedFilial !== "") {
        [coligadaFiltro, filialFiltro] = selectedFilial.split("-");
      }

      const response = await fetch(
        `${API_BASE_URL}/totvs-sql/sql_MAN_ORC_0006/filter`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({
            WHERE: `AND TIPO in('Despesas','Investimento')  AND CODCOLIGADA = '${coligadaFiltro}' AND CODFILIAL = '${filialFiltro}' AND ANO = '${ano}' AND CODUSUARIO='${currentUsername}'`,
            ORDER_BY: "CODFILIAL, CENTROCUSTO",
            DISTINCT: "CODCCUSTO, CENTROCUSTO",
          }),
        }
      );

      const result = await response.json();
      if (result.success && result.data) {
        // ✅ REMOÇÃO DE DUPLICATAS NO FRONTEND
        const centrosCustoUnicos = result.data.reduce((acc, item) => {
          const existe = acc.find((cc) => cc.CODCCUSTO === item.CODCCUSTO);
          if (!existe) {
            acc.push(item);
          }
          return acc;
        }, []);

        setCentrosCusto(centrosCustoUnicos);
      }
    } catch (error) {
      console.error("Erro ao carregar centros de custo:", error);
    }
  }, [ano, selectedFilial]); // ✅ ADICIONAR selectedFilial COMO DEPENDÊNCIA

  // ✅ 1. MODIFICAR A FUNÇÃO carregarNaturezas PARA ACEITAR CENTRO DE CUSTO
  const carregarNaturezas = useCallback(
    async (centroCusto = null) => {
      try {
        const { headers, PCODCOLIGADA, PCODFILIAL, currentUsername } =
          getAuthData();

        // ✅ USAR A FILIAL SELECIONADA OU A FILIAL PADRÃO DO USUÁRIO
        let coligadaFiltro = PCODCOLIGADA;
        let filialFiltro = PCODFILIAL;

        if (selectedFilial && selectedFilial !== "") {
          [coligadaFiltro, filialFiltro] = selectedFilial.split("-");
        }

        // ✅ CONSTRUIR WHERE CLAUSE COM FILTRO DE CENTRO DE CUSTO
        let whereClause = `AND TIPO in('Despesas','Investimento') AND CODCOLIGADA = '${coligadaFiltro}' AND CODFILIAL = '${filialFiltro}' AND ANO = '${ano}' AND CODUSUARIO='${currentUsername}'`;

        // ✅ ADICIONAR FILTRO POR CENTRO DE CUSTO SE FORNECIDO
        if (centroCusto && centroCusto !== "") {
          whereClause += ` AND CODCCUSTO = '${centroCusto}'`;
        }

        const response = await fetch(
          `${API_BASE_URL}/totvs-sql/sql_MAN_ORC_0006/filter`,
          {
            method: "POST",
            headers,
            body: JSON.stringify({
              WHERE: whereClause,
              ORDER_BY: "NATUREZA",
              DISTINCT: "CODTBORCAMENTO, NATUREZA",
            }),
          }
        );

        const result = await response.json();
        if (result.success && result.data) {
          // ✅ REMOÇÃO DE DUPLICATAS NO FRONTEND
          const naturezasUnicas = result.data.reduce((acc, item) => {
            const existe = acc.find(
              (nat) => nat.CODTBORCAMENTO === item.CODTBORCAMENTO
            );
            if (!existe) {
              acc.push(item);
            }
            return acc;
          }, []);

          setNaturezas(naturezasUnicas);
        } else {
          // ✅ LIMPAR NATUREZAS SE NÃO HOUVER DADOS
          setNaturezas([]);
        }
      } catch (error) {
        console.error("Erro ao carregar naturezas:", error);
        setNaturezas([]);
      }
    },
    [ano, selectedFilial]
  );

  // ✅ 2. ADICIONAR useEffect PARA MONITORAR MUDANÇAS NOS CENTROS DE CUSTO
  useEffect(() => {
    // Carregar naturezas quando centro de custo origem mudar
    if (transferencia.origemCentroCusto) {
      carregarNaturezas(transferencia.origemCentroCusto);
    } else {
      // Se não há centro de custo selecionado, carregar todas as naturezas
      carregarNaturezas();
    }
  }, [transferencia.origemCentroCusto, carregarNaturezas]);

  // ✅ 3. CRIAR FUNÇÕES ESPECÍFICAS PARA CARREGAR NATUREZAS POR ORIGEM E DESTINO
  const carregarNaturezasOrigem = useCallback(
    async (centroCusto) => {
      try {
        const { headers, PCODCOLIGADA, PCODFILIAL, currentUsername } =
          getAuthData();

        let coligadaFiltro = PCODCOLIGADA;
        let filialFiltro = PCODFILIAL;

        if (selectedFilial && selectedFilial !== "") {
          [coligadaFiltro, filialFiltro] = selectedFilial.split("-");
        }

        let whereClause = `AND TIPO in('Despesas','Investimento') AND CODCOLIGADA = '${coligadaFiltro}' AND CODFILIAL = '${filialFiltro}' AND ANO = '${ano}' AND CODUSUARIO='${currentUsername}'`;

        if (centroCusto && centroCusto !== "") {
          whereClause += ` AND CODCCUSTO = '${centroCusto}'`;
        }

        const response = await fetch(
          `${API_BASE_URL}/totvs-sql/sql_MAN_ORC_0006/filter`,
          {
            method: "POST",
            headers,
            body: JSON.stringify({
              WHERE: whereClause,
              ORDER_BY: "NATUREZA",
              DISTINCT: "CODTBORCAMENTO, NATUREZA",
            }),
          }
        );

        const result = await response.json();
        if (result.success && result.data) {
          const naturezasUnicas = result.data.reduce((acc, item) => {
            const existe = acc.find(
              (nat) => nat.CODTBORCAMENTO === item.CODTBORCAMENTO
            );
            if (!existe) {
              acc.push(item);
            }
            return acc;
          }, []);

          // ✅ CRIAR ESTADOS SEPARADOS PARA NATUREZAS DE ORIGEM E DESTINO
          setNaturezasOrigem(naturezasUnicas);
        } else {
          setDadosOrcamentoOrigem(null);
          setDadosOrcamentoDestino(null);
        }
      } catch (error) {
        console.error("Erro ao carregar naturezas origem:", error);
        setDadosOrcamentoOrigem(null);
        setDadosOrcamentoDestino(null);
      }
    },
    [ano, selectedFilial]
  );

  const carregarNaturezasDestino = useCallback(
    async (centroCusto) => {
      try {
        const { headers, PCODCOLIGADA, PCODFILIAL, currentUsername } =
          getAuthData();

        let coligadaFiltro = PCODCOLIGADA;
        let filialFiltro = PCODFILIAL;

        if (selectedFilial && selectedFilial !== "") {
          [coligadaFiltro, filialFiltro] = selectedFilial.split("-");
        }

        let whereClause = `AND TIPO in('Despesas','Investimento') AND CODCOLIGADA = '${coligadaFiltro}' AND CODFILIAL = '${filialFiltro}' AND ANO = '${ano}' AND CODUSUARIO='${currentUsername}'`;

        if (centroCusto && centroCusto !== "") {
          whereClause += ` AND CODCCUSTO = '${centroCusto}'`;
        }

        const response = await fetch(
          `${API_BASE_URL}/totvs-sql/sql_MAN_ORC_0006/filter`,
          {
            method: "POST",
            headers,
            body: JSON.stringify({
              WHERE: whereClause,
              ORDER_BY: "NATUREZA",
              DISTINCT: "CODTBORCAMENTO, NATUREZA",
            }),
          }
        );

        const result = await response.json();
        if (result.success && result.data) {
          const naturezasUnicas = result.data.reduce((acc, item) => {
            const existe = acc.find(
              (nat) => nat.CODTBORCAMENTO === item.CODTBORCAMENTO
            );
            if (!existe) {
              acc.push(item);
            }
            return acc;
          }, []);

          setNaturezasDestino(naturezasUnicas);
        } else {
          setNaturezasDestino([]);
        }
      } catch (error) {
        console.error("Erro ao carregar naturezas destino:", error);
        setNaturezasDestino([]);
      }
    },
    [ano, selectedFilial]
  );

  // ✅ 4. ADICIONAR NOVOS ESTADOS PARA NATUREZAS SEPARADAS
  const [naturezasOrigem, setNaturezasOrigem] = useState([]);
  const [naturezasDestino, setNaturezasDestino] = useState([]);

  // ✅ 5. ADICIONAR useEffect PARA MONITORAR CENTRO DE CUSTO DESTINO TAMBÉM
  useEffect(() => {
    if (transferencia.destinoCentroCusto) {
      carregarNaturezasDestino(transferencia.destinoCentroCusto);
    } else {
      setNaturezasDestino([]);
    }
  }, [transferencia.destinoCentroCusto, carregarNaturezasDestino]);

  // ✅ 1. CRIAR FUNÇÃO PARA BUSCAR ORÇAMENTO ESPECÍFICO
  const buscarDadosCompletosOrcamento = useCallback(
    async (centroCusto, natureza) => {
      try {
        const { headers, PCODCOLIGADA, PCODFILIAL, currentUsername } =
          getAuthData();

        let coligadaFiltro = PCODCOLIGADA;
        let filialFiltro = PCODFILIAL;

        if (selectedFilial && selectedFilial !== "") {
          [coligadaFiltro, filialFiltro] = selectedFilial.split("-");
        }

        let whereClause = `AND TIPO in('Despesas','Investimento') AND CODCOLIGADA = '${coligadaFiltro}' AND CODFILIAL = '${filialFiltro}' AND ANO = '${ano}' AND CODUSUARIO='${currentUsername}'`;

        if (centroCusto) {
          whereClause += ` AND CODCCUSTO = '${centroCusto}'`;
        }

        if (natureza) {
          whereClause += ` AND CODTBORCAMENTO = '${natureza}'`;
        }

        const response = await fetch(
          `${API_BASE_URL}/totvs-sql/sql_MAN_ORC_0005/filter`,
          {
            method: "POST",
            headers,
            body: JSON.stringify({
              PARAM: [
                {
                  CODFILIAL: filialFiltro,
                  CODCOLIGADA: coligadaFiltro,
                  ANO: ano,
                },
              ],
              WHERE: whereClause,
              ORDER_BY: "NATUREZA, CODTBORCAMENTO",
            }),
          }
        );

        const result = await response.json();
        if (result.success && result.data && result.data.length > 0) {
          const orcamento = result.data[0];
          // Retorna dados completos incluindo valores de saldo
          return {
            IDORCTO: orcamento.IDORCTO,
            VALOR_ORCADO: parseFloat(orcamento.VALOR_ORCADO || 0),
            VALOR_REALIZADO: parseFloat(orcamento.VALOR_REALIZADO || 0),
            SALDO: parseFloat(orcamento.SALDO || 0),
            CENTROCUSTO: orcamento.CENTROCUSTO,
            NATUREZA: orcamento.NATUREZA,
          };
        }
        return null;
      } catch (error) {
        console.error("Erro ao buscar dados do orçamento:", error);
        return null;
      }
    },
    [ano, selectedFilial]
  );

  // ✅ 2. useEffect PARA BUSCAR ORÇAMENTO ORIGEM QUANDO CENTRO DE CUSTO + NATUREZA ESTIVEREM SELECIONADOS
  useEffect(() => {
    const buscarDadosOrigem = async () => {
      if (transferencia.origemCentroCusto && transferencia.origemNatureza) {
        setLoading(true);
        const dados = await buscarDadosCompletosOrcamento(
          transferencia.origemCentroCusto,
          transferencia.origemNatureza
        );

        if (dados && dados.IDORCTO) {
          setDadosOrcamentoOrigem(dados);
          setTransferencia((prev) => ({
            ...prev,
            origemIdOrcto: dados.IDORCTO.toString(),
          }));
        } else {
          setDadosOrcamentoOrigem(null);
          setTransferencia((prev) => ({
            ...prev,
            origemIdOrcto: "",
          }));
        }
        setLoading(false);
      } else {
        setDadosOrcamentoOrigem(null);
        setTransferencia((prev) => ({
          ...prev,
          origemIdOrcto: "",
        }));
      }
    };

    buscarDadosOrigem();
  }, [
    transferencia.origemCentroCusto,
    transferencia.origemNatureza,
    buscarDadosCompletosOrcamento,
  ]);

  // ✅ 3. useEffect PARA BUSCAR ORÇAMENTO DESTINO QUANDO CENTRO DE CUSTO + NATUREZA ESTIVEREM SELECIONADOS
  useEffect(() => {
    const buscarDadosDestino = async () => {
      if (transferencia.destinoCentroCusto && transferencia.destinoNatureza) {
        setLoading(true);
        const dados = await buscarDadosCompletosOrcamento(
          transferencia.destinoCentroCusto,
          transferencia.destinoNatureza
        );

        if (dados && dados.IDORCTO) {
          setDadosOrcamentoDestino(dados);
          setTransferencia((prev) => ({
            ...prev,
            destinoIdOrcto: dados.IDORCTO.toString(),
          }));
        } else {
          setDadosOrcamentoDestino(null);
          setTransferencia((prev) => ({
            ...prev,
            destinoIdOrcto: "",
          }));
        }
        setLoading(false);
      } else {
        setDadosOrcamentoDestino(null);
        setTransferencia((prev) => ({
          ...prev,
          destinoIdOrcto: "",
        }));
      }
    };

    buscarDadosDestino();
  }, [
    transferencia.destinoCentroCusto,
    transferencia.destinoNatureza,
    buscarDadosCompletosOrcamento,
  ]);

  const carregarTransferencias = useCallback(async () => {
    try {
      const { headers, PCODCOLIGADA, PCODFILIAL } = getAuthData();

      let coligadaFiltro = PCODCOLIGADA;
      let filialFiltro = PCODFILIAL;
      const selectedYear = localStorage.getItem("selectedYear");

      if (selectedFilial && selectedFilial !== "") {
        [coligadaFiltro, filialFiltro] = selectedFilial.split("-");
      }

      let whereClause = `AND CODCOLIGADA = '${coligadaFiltro}' AND CODFILIAL = '${filialFiltro}' AND ANO = '${selectedYear}' `;

      /*let whereClause = `AND CODCOLIGADA = '${coligadaFiltro}' AND ANO = '${selectedYear}' `;*/

      const response = await fetch(
        `${API_BASE_URL}/totvs-sql/sql_Man_ORC_0012/filter`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({
            WHERE: whereClause,
            ORDER_BY: "IDTRANSFERENCIA DESC",
          }),
        }
      );

      const result = await response.json();
      if (result.success && result.data) {
        setTransferencias(result.data);
      }
    } catch (error) {
      console.error("Erro ao carregar transferências:", error);
    }
  }, [selectedFilial]);

  const carregarTransferenciasGlobal = useCallback(async () => {
    try {
      const { headers } = getAuthData();

      const selectedYear = localStorage.getItem("selectedYear");

      let whereClause = `AND ANO = '${selectedYear}' `;

      const response = await fetch(
        `${API_BASE_URL}/totvs-sql/sql_Man_ORC_0012/filter`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({
            WHERE: whereClause,
            ORDER_BY: "IDTRANSFERENCIA DESC",
          }),
        }
      );

      const result = await response.json();
      if (result.success && result.data) {
        setTransferenciasGlobal(result.data);
      }
    } catch (error) {
      console.error("Erro ao carregar transferências:", error);
    }
  }, []);

  // ✅ FUNÇÃO CORRIGIDA COM DEBUG E VALIDAÇÕES
  const criarTransferencia = useCallback(async () => {
    try {
      setLoading(true);

      // ✅ 1. DEBUG: Verificar estado atual da transferência
      console.log("🔍 Estado atual da transferência:", transferencia);

      const { headers, PCODCOLIGADA, PCODFILIAL, currentUsername } =
        getAuthData();

      // ✅ 2. CORRIGIR: Usar ano do state ao invés de localStorage
      const selectedYear = ano; // Usar o state 'ano' ao invés de localStorage

      // ✅ 3. DEBUG: Verificar dados de autenticação
      console.log("🔍 Dados auth:", {
        PCODCOLIGADA,
        PCODFILIAL,
        currentUsername,
        selectedYear,
        selectedFilial,
      });

      let coligadaFiltro = PCODCOLIGADA;
      let filialFiltro = PCODFILIAL;

      if (selectedFilial && selectedFilial !== "") {
        [coligadaFiltro, filialFiltro] = selectedFilial.split("-");
      }

      // ✅ 4. VALIDAÇÃO RIGOROSA ANTES DE CRIAR OBJETO
      if (!transferencia.origemCentroCusto) {
        alert("❌ Centro de Custo Origem é obrigatório");
        return;
      }
      if (!transferencia.destinoCentroCusto) {
        alert("❌ Centro de Custo Destino é obrigatório");
        return;
      }
      if (!transferencia.origemNatureza) {
        alert("❌ Natureza Origem é obrigatória");
        return;
      }
      if (!transferencia.destinoNatureza) {
        alert("❌ Natureza Destino é obrigatória");
        return;
      }
      if (!transferencia.origemIdOrcto) {
        alert("❌ ID Orçamento Origem não encontrado");
        return;
      }
      if (!transferencia.destinoIdOrcto) {
        alert("❌ ID Orçamento Destino não encontrado");
        return;
      }
      if (
        !transferencia.valorTransferido ||
        parseFloat(transferencia.valorTransferido) <= 0
      ) {
        alert("❌ Valor da transferência deve ser maior que zero");
        return;
      }
      if (!transferencia.motivo.trim()) {
        alert("❌ Motivo da transferência é obrigatório");
        return;
      }

      // ✅ VALIDAÇÃO DE SALDO SUFICIENTE
      const valorTransferencia = parseFloat(transferencia.valorTransferido);
      if (
        dadosOrcamentoOrigem &&
        valorTransferencia > dadosOrcamentoOrigem.SALDO
      ) {
        alert(
          `❌ Saldo insuficiente!\n\nSaldo disponível: ${formatCurrency(
            dadosOrcamentoOrigem.SALDO
          )}\nValor solicitado: ${formatCurrency(
            valorTransferencia
          )}\nDiferença: ${formatCurrency(
            valorTransferencia - dadosOrcamentoOrigem.SALDO
          )}`
        );
        return;
      }

      // ✅ 5. CRIAR OBJETO COM VALIDAÇÃO DE TIPOS
      const novaTransferencia = {
        CODCOLIGADA: coligadaFiltro,
        CODFILIAL: filialFiltro,
        ANO: selectedYear.toString(), // Garantir que é string
        MOTIVO: transferencia.motivo.trim(),
        OBSERVACOES: transferencia.observacoes?.trim() || "",
        CRIADO_POR: currentUsername,

        // Origem
        CODCCUSTO_ORIGEM: transferencia.origemCentroCusto,
        CODTBORCAMENTO_ORIGEM: transferencia.origemNatureza,
        IDORCTO_ORIGEM: parseInt(transferencia.origemIdOrcto, 10),
        VALOR_TRANSFERIDO: parseFloat(transferencia.valorTransferido),

        // Destino
        CODCCUSTO_DESTINO: transferencia.destinoCentroCusto,
        CODTBORCAMENTO_DESTINO: transferencia.destinoNatureza,
        IDORCTO_DESTINO: parseInt(transferencia.destinoIdOrcto, 10),
        JUSTIFICATIVA_DESTINO: transferencia.justificativaDestino?.trim() || "",
      };

      // ✅ 6. DEBUG: Verificar objeto final antes do envio
      console.log("🔍 Objeto que será enviado:", novaTransferencia);

      // ✅ 7. VALIDAR SE NaN nos campos numéricos
      if (isNaN(novaTransferencia.IDORCTO_ORIGEM)) {
        alert("❌ Erro: ID Orçamento Origem inválido");
        return;
      }
      if (isNaN(novaTransferencia.IDORCTO_DESTINO)) {
        alert("❌ Erro: ID Orçamento Destino inválido");
        return;
      }
      if (isNaN(novaTransferencia.VALOR_TRANSFERIDO)) {
        alert("❌ Erro: Valor da transferência inválido");
        return;
      }

      // ✅ 8. DEBUG: Mostrar payload completo
      const payload = { novaTransferencia };
      console.log("🔍 Payload completo:", JSON.stringify(payload, null, 2));

      const response = await fetch(
        `${API_BASE_URL}/SQlCustom/createTransferencia`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result.IDTRANSFERENCIA) {
        // ✅ TENTAR ENVIAR EMAIL DE APROVAÇÃO
        try {
          console.log("📧 Tentando enviar email de aprovação...");
          const emailResult = await enviarEmailAprovacao(
            result.IDTRANSFERENCIA
          );

          if (emailResult.success) {
            alert(
              `✅ Transferência enviada com sucesso!`
            );
          } else {
            alert(
              `✅ Transferência registrada com sucesso!`
            );
          }
        } catch (emailError) {
          console.error("❌ Erro no envio de email (não crítico):", emailError);
          alert(
            "✅ Transferência registrada com sucesso!⚠️ Porém não foi possível enviar email de notificação."
          );
        }
      }

      // ✅ 9. DEBUG: Mostrar resposta do servidor
      console.log("🔍 Resposta do servidor:", result);

      if (result.IDTRANSFERENCIA) {
        alert("✅ Transferência criada com sucesso!");

        // ✅ 10. LIMPAR FORMULÁRIO APÓS SUCESSO
        setTransferencia({
          origemFilial: "",
          destinoFilial: "",
          origemCentroCusto: "",
          destinoCentroCusto: "",
          origemNatureza: "",
          destinoNatureza: "",
          origemIdOrcto: "",
          destinoIdOrcto: "",
          valorTransferido: "",
          motivo: "",
          observacoes: "",
          justificativaDestino: "",
        });

        // Limpar listas de naturezas
        setDadosOrcamentoOrigem(null);
        setDadosOrcamentoDestino(null);

        await carregarTransferencias();
        await carregarTransferenciasGlobal();
        await carregarDashboard();
      } else {
        alert(
          `❌ Erro ao criar transferência: ${
            result.details || "Erro desconhecido"
          }`
        );
        setTransferencia({
          origemFilial: "",
          destinoFilial: "",
          origemCentroCusto: "",
          destinoCentroCusto: "",
          origemNatureza: "",
          destinoNatureza: "",
          origemIdOrcto: "",
          destinoIdOrcto: "",
          valorTransferido: "",
          motivo: "",
          observacoes: "",
          justificativaDestino: "",
        });

        // Limpar listas de naturezas
        setDadosOrcamentoOrigem(null);
        setDadosOrcamentoDestino(null);
      }
    } catch (error) {
      console.error("❌ Erro ao criar transferência:", error);
      alert(`❌ Erro: ${error.details}`);

      setTransferencia({
        origemFilial: "",
        destinoFilial: "",
        origemCentroCusto: "",
        destinoCentroCusto: "",
        origemNatureza: "",
        destinoNatureza: "",
        origemIdOrcto: "",
        destinoIdOrcto: "",
        valorTransferido: "",
        motivo: "",
        observacoes: "",
        justificativaDestino: "",
      });

      // Limpar listas de naturezas
      setDadosOrcamentoOrigem(null);
      setDadosOrcamentoDestino(null);
    } finally {
      setLoading(false);
    }
  }, [
    transferencia,
    selectedFilial,
    ano,
    dadosOrcamentoOrigem, // ✅ ADICIONAR ESTA DEPENDÊNCIA
    carregarTransferencias,
    carregarTransferenciasGlobal,
    carregarDashboard,
  ]);

  // ✅ FUNÇÃO aprovarTransferencia CORRIGIDA (IGUAL À CRIAÇÃO)
  const aprovarTransferencia = async (idTransferencia) => {
    try {
      setLoading(true);

      // ✅ 1. DEBUG: Verificar dados da aprovação
      console.log("🔍 Iniciando aprovação da transferência:", idTransferencia);

      const { headers, PCODCOLIGADA, PCODFILIAL, currentUsername } =
        getAuthData();
      const selectedYear = ano; // Usar o state 'ano' ao invés de localStorage

      // ✅ 2. DEBUG: Verificar dados de autenticação
      console.log("🔍 Dados auth para aprovação:", {
        PCODCOLIGADA,
        PCODFILIAL,
        currentUsername,
        selectedYear,
        selectedFilial,
        idTransferencia,
      });

      let coligadaFiltro = PCODCOLIGADA;
      let filialFiltro = PCODFILIAL;

      if (selectedFilial && selectedFilial !== "") {
        [coligadaFiltro, filialFiltro] = selectedFilial.split("-");
      }

      // ✅ 3. VALIDAÇÃO RIGOROSA ANTES DE APROVAR
      if (!idTransferencia) {
        alert("❌ ID da transferência é obrigatório");
        setLoading(false);
        return;
      }

      if (!currentUsername) {
        alert("❌ Usuário não identificado");
        setLoading(false);
        return;
      }

      // ✅ 4. CRIAR OBJETO PARA APROVAÇÃO
      const dadosAprovacao = {
        IDTRANSFERENCIA: parseInt(idTransferencia, 10),
        APROVADO_POR: currentUsername,
        CODCOLIGADA: coligadaFiltro,
        CODFILIAL: filialFiltro,
        ANO: selectedYear.toString(),
        OBSERVACOES: "Aprovado via sistema",
        DATA_APROVACAO: new Date().toISOString(),
        STATUS: "APROVADA",
      };

      // ✅ 5. DEBUG: Verificar objeto de aprovação
      console.log(
        "🔍 Dados que serão enviados para aprovação:",
        dadosAprovacao
      );

      // ✅ 6. VALIDAR SE NaN no ID
      if (isNaN(dadosAprovacao.IDTRANSFERENCIA)) {
        alert("❌ Erro: ID da transferência inválido");
        setLoading(false);
        return;
      }

      // ✅ 7. DEBUG: Mostrar payload completo
      const payload = { dadosAprovacao };
      console.log(
        "🔍 Payload completo para aprovação:",
        JSON.stringify(payload, null, 2)
      );

      // ✅ 8. USAR ROTA ESPECÍFICA PARA APROVAÇÃO (IGUAL À CRIAÇÃO)
      const response = await fetch(
        `${API_BASE_URL}/SQlCustom/aprovarTransferencia`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result.IDTRANSFERENCIA) {
        // ✅ TENTAR ENVIAR EMAIL DE APROVAÇÃO
        try {
          console.log("📧 Tentando enviar email de aprovação...");
          const emailResult = await enviarEmailAprovado(result.IDTRANSFERENCIA);

          if (emailResult.success) {
            alert(
              `✅ Transferência aprovada com sucesso!`
            );
          } else {
            alert(
              `✅ Transferência aprovada com sucesso!\n⚠️ Porém houve problema no envio do email.`
            );
          }
        } catch (emailError) {
          console.error("❌ Erro no envio de email (não crítico):", emailError);
          alert(
            "✅ Transferência aprovada com sucesso!\n⚠️ Porém não foi possível enviar email de notificação."
          );
        }
      }

      // ✅ 9. DEBUG: Mostrar resposta do servidor
      console.log("🔍 Resposta do servidor (aprovação):", result);

      if (result.success) {
        alert("✅ Transferência aprovada com sucesso!");

        // ✅ 10. RECARREGAR DADOS DE FORMA SEGURA
        await recarregarDados();
      } else {
        alert(
          `❌ Erro ao aprovar transferência: ${
            result.message || "Erro desconhecido"
          }`
        );
      }
    } catch (error) {
      console.error("❌ Erro ao aprovar transferência:", error);
      alert(`❌ Erro: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // ✅ FUNÇÃO reprovarTransferencia TAMBÉM CORRIGIDA
  const reprovarTransferencia = async (
    idTransferencia,
    motivo = "Reprovado via sistema"
  ) => {
    try {
      setLoading(true);

      // ✅ 1. DEBUG: Verificar dados da reprovação
      console.log(
        "🔍 Iniciando reprovação da transferência:",
        idTransferencia,
        "Motivo:",
        motivo
      );

      const { headers, PCODCOLIGADA, PCODFILIAL, currentUsername } =
        getAuthData();
      const selectedYear = ano;

      // ✅ 2. DEBUG: Verificar dados de autenticação
      console.log("🔍 Dados auth para reprovação:", {
        PCODCOLIGADA,
        PCODFILIAL,
        currentUsername,
        selectedYear,
        selectedFilial,
        idTransferencia,
        motivo,
      });

      let coligadaFiltro = PCODCOLIGADA;
      let filialFiltro = PCODFILIAL;

      if (selectedFilial && selectedFilial !== "") {
        [coligadaFiltro, filialFiltro] = selectedFilial.split("-");
      }

      // ✅ 3. VALIDAÇÃO RIGOROSA
      if (!idTransferencia) {
        alert("❌ ID da transferência é obrigatório");
        setLoading(false);
        return;
      }

      if (!currentUsername) {
        alert("❌ Usuário não identificado");
        setLoading(false);
        return;
      }

      if (!motivo || motivo.trim() === "") {
        alert("❌ Motivo da reprovação é obrigatório");
        setLoading(false);
        return;
      }

      // ✅ 4. CRIAR OBJETO PARA REPROVAÇÃO
      const dadosReprovacao = {
        IDTRANSFERENCIA: parseInt(idTransferencia, 10),
        REPROVADO_POR: currentUsername,
        CODCOLIGADA: coligadaFiltro,
        CODFILIAL: filialFiltro,
        ANO: selectedYear.toString(),
        MOTIVO_REJEICAO: motivo.trim(),
        DATA_REPROVACAO: new Date().toISOString(),
        STATUS: "REJEITADA",
      };

      // ✅ 5. DEBUG: Verificar objeto de reprovação
      console.log(
        "🔍 Dados que serão enviados para reprovação:",
        dadosReprovacao
      );

      // ✅ 6. VALIDAR SE NaN no ID
      if (isNaN(dadosReprovacao.IDTRANSFERENCIA)) {
        alert("❌ Erro: ID da transferência inválido");
        setLoading(false);
        return;
      }

      // ✅ 7. USAR ROTA ESPECÍFICA PARA REPROVAÇÃO
      const payload = { dadosReprovacao };
      console.log(
        "🔍 Payload completo para reprovação:",
        JSON.stringify(payload, null, 2)
      );

      const response = await fetch(
        `${API_BASE_URL}/SQlCustom/reprovarTransferencia`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result.IDTRANSFERENCIA) {
        // ✅ TENTAR ENVIAR EMAIL DE APROVAÇÃO
        try {
          console.log("📧 Tentando enviar email de aprovação...");
          const emailResult = await enviarEmailReprovado(
            result.IDTRANSFERENCIA
          );

          if (emailResult.success) {
            alert(
              `✅ Transferência reprovada com sucesso!`
            );
          } else {
            alert(
              `✅ Transferência reprovada com sucesso!\n⚠️ Porém houve problema no envio do email.`
            );
          }
        } catch (emailError) {
          console.error("❌ Erro no envio de email (não crítico):", emailError);
          alert(
            "✅ Transferência reprovada com sucesso!\n⚠️ Porém não foi possível enviar email de notificação."
          );
        }
      }

      // ✅ 8. DEBUG: Mostrar resposta do servidor
      console.log("🔍 Resposta do servidor (reprovação):", result);

      if (result.success) {
        alert("❌ Transferência reprovada com sucesso!");

        // ✅ 9. RECARREGAR DADOS DE FORMA SEGURA
        await recarregarDados();
      } else {
        alert(
          `❌ Erro ao reprovar transferência: ${
            result.message || "Erro desconhecido"
          }`
        );
      }
    } catch (error) {
      console.error("❌ Erro ao reprovar transferência:", error);
      alert(`❌ Erro: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // ✅ FUNÇÃO efetivarTransferencia TAMBÉM CORRIGIDA
  const efetivarTransferencia = async (idTransferencia) => {
    try {
      setLoading(true);

      // ✅ 1. DEBUG: Verificar dados da efetivação
      console.log("🔍 Iniciando efetivação da transferência:", idTransferencia);

      const { headers, PCODCOLIGADA, PCODFILIAL, currentUsername } =
        getAuthData();
      const selectedYear = ano;

      // ✅ 2. DEBUG: Verificar dados de autenticação
      console.log("🔍 Dados auth para efetivação:", {
        PCODCOLIGADA,
        PCODFILIAL,
        currentUsername,
        selectedYear,
        selectedFilial,
        idTransferencia,
      });

      let coligadaFiltro = PCODCOLIGADA;
      let filialFiltro = PCODFILIAL;

      if (selectedFilial && selectedFilial !== "") {
        [coligadaFiltro, filialFiltro] = selectedFilial.split("-");
      }

      // ✅ 3. VALIDAÇÃO RIGOROSA
      if (!idTransferencia) {
        alert("❌ ID da transferência é obrigatório");
        setLoading(false);
        return;
      }

      if (!currentUsername) {
        alert("❌ Usuário não identificado");
        setLoading(false);
        return;
      }

      // ✅ 4. CRIAR OBJETO PARA EFETIVAÇÃO
      const dadosEfetivacao = {
        IDTRANSFERENCIA: parseInt(idTransferencia, 10),
        EFETIVADO_POR: currentUsername,
        CODCOLIGADA: coligadaFiltro,
        CODFILIAL: filialFiltro,
        ANO: selectedYear.toString(),
        DATA_EFETIVACAO: new Date().toISOString(),
        STATUS: "EFETIVADA",
      };

      // ✅ 5. DEBUG: Verificar objeto de efetivação
      console.log(
        "🔍 Dados que serão enviados para efetivação:",
        dadosEfetivacao
      );

      // ✅ 6. VALIDAR SE NaN no ID
      if (isNaN(dadosEfetivacao.IDTRANSFERENCIA)) {
        alert("❌ Erro: ID da transferência inválido");
        setLoading(false);
        return;
      }

      // ✅ 7. USAR ROTA ESPECÍFICA PARA EFETIVAÇÃO
      const payload = { dadosEfetivacao };
      console.log(
        "🔍 Payload completo para efetivação:",
        JSON.stringify(payload, null, 2)
      );

      const response = await fetch(
        `${API_BASE_URL}/SQlCustom/efetivarTransferencia`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      // ✅ 8. DEBUG: Mostrar resposta do servidor
      console.log("🔍 Resposta do servidor (efetivação):", result);

      if (result.success) {
        alert("🔄 Transferência efetivada! Orçamentos atualizados.");

        // ✅ 9. RECARREGAR DADOS DE FORMA SEGURA
        await recarregarDados();
      } else {
        alert(
          `❌ Erro ao efetivar transferência: ${
            result.message || "Erro desconhecido"
          }`
        );
      }
    } catch (error) {
      console.error("❌ Erro ao efetivar transferência:", error);
      alert(`❌ Erro: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const confirmarAprovacao = async (transferencia) => {
    const confirmar = window.confirm(
      `✅ APROVAR TRANSFERÊNCIA?\n\n` +
        `📋 Número: ${transferencia.NUMERO_TRANSFERENCIA}\n` +
        `💰 Valor: ${formatCurrency(transferencia.VALOR_TOTAL)}\n` +
        `👤 Solicitante: ${transferencia.CRIADO_POR}\n` +
        `📤 De: ${transferencia.CENTROCUSTO_ORIGEM}\n` +
        `📥 Para: ${transferencia.CENTROCUSTO_DESTINO}\n\n` +
        `Confirma a aprovação?`
    );

    if (confirmar) {
      console.log(
        "🔍 Usuário confirmou aprovação da transferência:",
        transferencia.IDTRANSFERENCIA
      );
      await aprovarTransferencia(transferencia.IDTRANSFERENCIA);
      await efetivarTransferencia(transferencia.IDTRANSFERENCIA);
    } else {
      console.log("❌ Usuário cancelou aprovação");
    }
  };

  const confirmarReprovacao = async (transferencia) => {
    const motivo = window.prompt(
      `❌ REPROVAR TRANSFERÊNCIA\n\n` +
        `📋 Número: ${transferencia.NUMERO_TRANSFERENCIA}\n` +
        `💰 Valor: ${formatCurrency(transferencia.VALOR_TOTAL)}\n` +
        `👤 Solicitante: ${transferencia.CRIADO_POR}\n\n` +
        `⚠️ Esta ação irá rejeitar definitivamente a transferência.\n\n` +
        `Digite o motivo da reprovação:`,
      "Não atende aos critérios estabelecidos"
    );

    if (motivo && motivo.trim()) {
      console.log("🔍 Usuário confirmou reprovação com motivo:", motivo);
      await reprovarTransferencia(transferencia.IDTRANSFERENCIA, motivo.trim());
    } else if (motivo === "") {
      alert("❌ É obrigatório informar o motivo da reprovação!");
    } else {
      console.log("❌ Usuário cancelou reprovação");
    }
  };

  const enviarEmailAprovacao = async (idTransferencia) => {
    try {
      console.log(
        "📧 Enviando email de aprovação para transferência:",
        idTransferencia
      );

      const { headers, PCODCOLIGADA, PCODFILIAL } = getAuthData();

      // ✅ PREPARAR DADOS PARA O EMAIL
      const userInfo = {
        CODCOLIGADA: PCODCOLIGADA,
        CODFILIAL: PCODFILIAL,
      };

      const payload = {
        idTransferencia: parseInt(idTransferencia, 10),
        userInfo,
      };

      console.log("📧 Payload para email:", payload);

      const response = await fetch(
        `${API_BASE_URL}/SQlCustom/processarEmailAprovacao`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result.success) {
        console.log("✅ Email de Transferência enviado:", result.data);
        return {
          success: true,
          message: `Email enviado para ${result.data.emailsEnviados} destinatário(s)`,
          data: result.data,
        };
      } else {
        console.warn("⚠️ Falha no envio do email:", result.message);
        return {
          success: false,
          message: result.message || "Erro ao enviar email",
        };
      }
    } catch (error) {
      console.error("❌ Erro ao enviar email de aprovação:", error);
      return {
        success: false,
        message: "Erro de rede ao enviar email",
      };
    }
  };

  const enviarEmailAprovado = async (idTransferencia) => {
    try {
      console.log(
        "📧 Enviando email de aprovação para transferência:",
        idTransferencia
      );

      const { headers, PCODCOLIGADA, PCODFILIAL } = getAuthData();

      // ✅ PREPARAR DADOS PARA O EMAIL
      const userInfo = {
        CODCOLIGADA: PCODCOLIGADA,
        CODFILIAL: PCODFILIAL,
      };

      const payload = {
        idTransferencia: parseInt(idTransferencia, 10),
        userInfo,
      };

      console.log("📧 Payload para email:", payload);

      const response = await fetch(
        `${API_BASE_URL}/SQlCustom/confirmarAprovacaoGeani`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result.success) {
        console.log("✅ Email de aprovação enviado:", result.data);
        return {
          success: true,
          message: `Email enviado para ${result.data.emailsEnviados} destinatário(s)`,
          data: result.data,
        };
      } else {
        console.warn("⚠️ Falha no envio do email:", result.message);
        return {
          success: false,
          message: result.message || "Erro ao enviar email",
        };
      }
    } catch (error) {
      console.error("❌ Erro ao enviar email de aprovação:", error);
      return {
        success: false,
        message: "Erro de rede ao enviar email",
      };
    }
  };

  const enviarEmailReprovado = async (idTransferencia) => {
    try {
      console.log(
        "📧 Enviando email de aprovação para transferência:",
        idTransferencia
      );

      const { headers, PCODCOLIGADA, PCODFILIAL } = getAuthData();

      // ✅ PREPARAR DADOS PARA O EMAIL
      const userInfo = {
        CODCOLIGADA: PCODCOLIGADA,
        CODFILIAL: PCODFILIAL,
      };

      const payload = {
        idTransferencia: parseInt(idTransferencia, 10),
        userInfo,
      };

      console.log("📧 Payload para email:", payload);

      const response = await fetch(
        `${API_BASE_URL}/SQlCustom/confirmarReprovacaoGeani`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (result.success) {
        console.log("✅ Email de reprovação enviado:", result.data);
        return {
          success: true,
          message: `Email enviado para ${result.data.emailsEnviados} destinatário(s)`,
          data: result.data,
        };
      } else {
        console.warn("⚠️ Falha no envio do email:", result.message);
        return {
          success: false,
          message: result.message || "Erro ao enviar email",
        };
      }
    } catch (error) {
      console.error("❌ Erro ao enviar email de reprovação:", error);
      return {
        success: false,
        message: "Erro de rede ao enviar email",
      };
    }
  };

  // ✅ INICIALIZAÇÃO
  useEffect(() => {
    // ✅ VERIFICAR PERMISSÕES LOGO NO INÍCIO
    checkApprovalPermissions();

    fetchAvailableFiliais();
    carregarDashboard();
    carregarCentrosCusto();
    carregarNaturezas();
    carregarTransferencias();
    carregarTransferenciasGlobal();
  }, [
    carregarDashboard,
    carregarCentrosCusto,
    carregarNaturezas,
    carregarTransferencias,
    carregarTransferenciasGlobal,
  ]);

  // ✅ 1. MODIFICAR O useEffect PARA LIMPAR TODOS OS ESTADOS QUANDO FILIAL MUDAR
  useEffect(() => {
    if (selectedFilial !== "") {
      // ✅ LIMPAR TODOS OS ESTADOS RELACIONADOS AO FORMULÁRIO
      setTransferencia({
        origemFilial: "",
        destinoFilial: "",
        origemCentroCusto: "",
        destinoCentroCusto: "",
        origemNatureza: "",
        destinoNatureza: "",
        origemIdOrcto: "",
        destinoIdOrcto: "",
        valorTransferido: "",
        motivo: "",
        observacoes: "",
        justificativaDestino: "",
      });

      // ✅ LIMPAR NATUREZAS ORIGEM E DESTINO
      setDadosOrcamentoOrigem(null);
      setDadosOrcamentoDestino(null);

      // ✅ LIMPAR OUTROS ESTADOS RELACIONADOS
      setCentrosCusto([]);
      setNaturezas([]);

      // ✅ RECARREGAR DADOS DA NOVA FILIAL
      carregarDashboard();
      carregarCentrosCusto();
      carregarNaturezas();
      carregarTransferencias();
      carregarTransferenciasGlobal();
    }
  }, [
    selectedFilial,
    carregarDashboard,
    carregarCentrosCusto,
    carregarNaturezas,
    carregarTransferencias,
    carregarTransferenciasGlobal,
  ]);

  // ✅ FUNÇÕES AUXILIARES
  const formatCurrency = (value) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      PENDENTE: "warning",
      APROVADA: "success",
      REJEITADA: "danger",
      EFETIVADA: "info",
      CANCELADA: "secondary",
    };
    return statusMap[status] || "secondary";
  };

  const getStatusText = (status) => {
    const statusMap = {
      PENDENTE: "Aguardando Aprovação",
      APROVADA: "Aprovada",
      REJEITADA: "Rejeitada",
      EFETIVADA: "Efetivada",
      CANCELADA: "Cancelada",
    };
    return statusMap[status] || status;
  };

  const filteredFiliais = filiais.filter((filial) =>
    filial.NOMEFANTASIA.toLowerCase().includes(searchTerm.toLowerCase())
  );

  /*const uniqueFiliais = filteredFiliais.filter(
    (filial, idx, self) =>
      self.findIndex((f) => f.CHAVE_UNICA === filial.CHAVE_UNICA) === idx
  );*/

  const uniqueFiliais = filteredFiliais
    .filter(
      (filial, idx, self) =>
        self.findIndex((f) => f.CHAVE_UNICA === filial.CHAVE_UNICA) === idx
    )
    .sort((a, b) => {
      // Ordenar por CODFILIAL - trata como string mas com ordenação numérica se possível
      const aCode = a.CODFILIAL?.toString() || "";
      const bCode = b.CODFILIAL?.toString() || "";

      // Se ambos são números, compara numericamente
      if (!isNaN(aCode) && !isNaN(bCode)) {
        return parseInt(aCode, 10) - parseInt(bCode, 10);
      }

      // Caso contrário, compara como string
      return aCode.localeCompare(bCode);
    });

  // ✅ VALIDAÇÃO DOS FORMULÁRIOS
  const canSubmitTransferencia = () => {
    return (
      transferencia.origemCentroCusto &&
      transferencia.destinoCentroCusto &&
      transferencia.origemNatureza &&
      transferencia.destinoNatureza &&
      transferencia.origemIdOrcto && // ✅ DEVE TER SIDO PREENCHIDO AUTOMATICAMENTE
      transferencia.destinoIdOrcto && // ✅ DEVE TER SIDO PREENCHIDO AUTOMATICAMENTE
      transferencia.valorTransferido &&
      transferencia.motivo &&
      !loading // ✅ NÃO PERMITIR SUBMIT DURANTE CARREGAMENTO
    );
  };

  return (
    <div
      className="container-fluid"
      style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}
    >
      {/* Header */}
      <div className="row py-3">
        <div className="col-12 text-center">
          <h2
            className="text-dark fw-semibold mb-4"
            style={{ fontSize: "2.20rem" }}
          >
            💰 Sistema de Transferência e Solicitação de Verba -{" "}
            {localStorage.getItem("selectedYear")}
          </h2>
          <h3 className="text-dark">Congregação de Santa Cruz</h3>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="row mt-4 mb-4">
        <div className="col-12">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "dashboard" ? "active" : ""
                }`}
                onClick={() => setActiveTab("dashboard")}
              >
                📊 Dashboard
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "lancamento" ? "active" : ""
                }`}
                onClick={() => setActiveTab("lancamento")}
              >
                📝 Nova Transferência
              </button>
            </li>
            {/* ✅ CONDICIONAL PARA MOSTRAR ABA APENAS PARA USUÁRIOS AUTORIZADOS */}
            {canApprove && (
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "aguardando" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("aguardando")}
                >
                  ⏳ Aguardando Aprovação ({dashboardData.aguardandoAprovacao})
                </button>
              </li>
            )}
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "aprovacao" ? "active" : ""
                }`}
                onClick={() => setActiveTab("aprovacao")}
              >
                ✅ Aprovadas ({dashboardData.aprovados})
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "reprovacao" ? "active" : ""
                }`}
                onClick={() => setActiveTab("reprovacao")}
              >
                ❌ Rejeitadas ({dashboardData.reprovados})
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "historico" ? "active" : ""
                }`}
                onClick={() => setActiveTab("historico")}
              >
                📈 Histórico ({dashboardData.totalTransferencias})
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Loading Indicator */}
      {loading && (
        <div className="row">
          <div className="col-12 text-center py-3">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Carregando...</span>
            </div>
            <p className="mt-2">Processando...</p>
          </div>
        </div>
      )}

      {/* Dashboard Tab */}
      {activeTab === "dashboard" && (
        <div className="row">
          <div className="col-md-4">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-dark text-white">
                <h6 className="card-title mb-0">🏢 Filtrar por Filial</h6>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <select
                    className="form-select"
                    value={selectedFilial}
                    onChange={(e) => {
                      setSelectedFilial(e.target.value);
                      // ✅ OPCIONAL: FEEDBACK VISUAL IMEDIATO
                      if (e.target.value === "") {
                        // Voltou para "Todas as Filiais" - poderia mostrar algum feedback
                        console.log("Carregando dados de todas as filiais...");
                      } else {
                        console.log(
                          `Carregando dados da filial: ${e.target.value}`
                        );
                      }
                    }}
                  >
                    <option value="">Todas as Filiais</option>
                    {uniqueFiliais.map((filial) => (
                      <option
                        key={filial.CHAVE_UNICA}
                        value={filial.CHAVE_UNICA}
                      >
                        {filial.CODFILIAL} – {filial.NOMEFANTASIA}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-8">
            {/* Cards Financeiros Principais */}
            <div className="row mb-3">
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-md-6 col-lg-3 mb-3">
                    <div
                      className="card border-0 shadow-sm h-100"
                      style={{
                        background:
                          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      }}
                    >
                      <div className="card-body text-white text-center">
                        <div className="display-6">💰</div>
                        <h6 className="card-title mb-2">Orçado</h6>
                        <h5 className="mb-0">
                          {formatCurrency(dashboardData.valorOrcado)}
                        </h5>
                        <small className="opacity-75">Total Ano {ano}</small>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-3 mb-3">
                    <div
                      className="card border-0 shadow-sm h-100"
                      style={{
                        background:
                          "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                      }}
                    >
                      <div className="card-body text-white text-center">
                        <div className="display-6">📊</div>
                        <h6 className="card-title mb-2">Realizado</h6>
                        <h5 className="mb-0">
                          {formatCurrency(dashboardData.valorRealizado)}
                        </h5>
                        <small className="opacity-75">Executado até hoje</small>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-3 mb-3">
                    <div
                      className="card border-0 shadow-sm h-100"
                      style={{
                        background:
                          "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
                      }}
                    >
                      <div className="card-body text-white text-center">
                        <div className="display-6">💵</div>
                        <h6 className="card-title mb-2">Saldo</h6>
                        <h5 className="mb-0">
                          {formatCurrency(dashboardData.saldo)}
                        </h5>
                        <small className="opacity-75">Disponível</small>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-3 mb-3">
                    <div
                      className="card border-0 shadow-sm h-100"
                      style={{
                        background:
                          "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
                      }}
                    >
                      <div className="card-body text-white text-center">
                        <div className="display-6">🔄</div>
                        <h6 className="card-title mb-2">Transferências</h6>
                        <h5 className="mb-0">
                          {dashboardData.totalTransferencias}
                        </h5>
                        <small className="opacity-75">Total no ano</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Estatísticas */}
            <div className="row mb-3">
              <div className="col-md-4">
                <div
                  className="card border-0 shadow-sm"
                  onClick={() => setActiveTab("aprovacao")}
                  style={{ cursor: "pointer", transition: "transform 0.2s" }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.02)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                >
                  <div className="card-body text-center">
                    <h6 className="card-title text-success">✅ Aprovadas</h6>
                    <h4 className="text-success">{dashboardData.aprovados}</h4>
                    <small className="text-muted">
                      Clique para ver detalhes
                    </small>
                  </div>
                </div>
              </div>
                <div className="col-md-4">
                  <div
                    className="card border-0 shadow-sm"
                    onClick={() => canApprove && setActiveTab("aguardando")}
                    style={{ 
                      cursor: canApprove ? "pointer" : "not-allowed",
                      transition: "transform 0.2s",
                      opacity: canApprove ? 1 : 0.6
                    }}
                    onMouseEnter={(e) =>
                      canApprove && (e.currentTarget.style.transform = "scale(1.02)")
                    }
                    onMouseLeave={(e) =>
                      canApprove && (e.currentTarget.style.transform = "scale(1)")
                    }
                  >
                    <div className="card-body text-center">
                      <h6 className="card-title text-warning">⏳ Pendentes</h6>
                      <h4 className="text-warning">
                        {dashboardData.aguardandoAprovacao}
                      </h4>
                      <small className="text-muted">
                        {canApprove 
                          ? "Clique para ver detalhes" 
                          : "Acesso restrito aos aprovadores"}
                      </small>
                    </div>
                  </div>
                </div>

              {/*<div className="col-md-4">
                <div
                  className="card border-0 shadow-sm"
                  onClick={() => setActiveTab("aguardando")}
                  style={{ cursor: "pointer", transition: "transform 0.2s" }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.02)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                >
                  <div className="card-body text-center">
                    <h6 className="card-title text-warning">⏳ Pendentes</h6>
                    <h4 className="text-warning">
                      {dashboardData.aguardandoAprovacao}
                    </h4>
                    <small className="text-muted">
                      Clique para ver detalhes
                    </small>
                  </div>
                </div>
              </div> */}
              <div className="col-md-4">
                <div
                  className="card border-0 shadow-sm"
                  onClick={() => setActiveTab("reprovacao")}
                  style={{ cursor: "pointer", transition: "transform 0.2s" }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.02)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                >
                  <div className="card-body text-center">
                    <h6 className="card-title text-danger">❌ Rejeitadas</h6>
                    <h4 className="text-danger">{dashboardData.reprovados}</h4>
                    <small className="text-muted">
                      Clique para ver detalhes
                    </small>
                  </div>
                </div>
              </div>
            </div>

            {/* Movimentações Recentes */}
            <div className="card border-0 shadow-sm">
              <div className="card-header">
                <h6 className="card-title mb-0">📈 Transferências Recentes</h6>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th>Data</th>
                        <th>Número</th>
                        <th>Origem → Destino</th>
                        <th>Valor</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transferencias.slice(0, 5).map((item) => (
                        <tr key={item.IDTRANSFERENCIA}>
                          <td>
                            {new Date(item.DATA_SOLICITACAO).toLocaleDateString(
                              "pt-BR"
                            )}
                          </td>
                          <td>
                            <code>{item.NUMERO_TRANSFERENCIA}</code>
                          </td>
                          <td>
                            <small>
                              {item.CENTROCUSTO_ORIGEM} →{" "}
                              {item.CENTROCUSTO_DESTINO}
                              <br />
                              <span className="text-muted">
                                {item.NATUREZA_ORIGEM} → {item.NATUREZA_DESTINO}
                              </span>
                            </small>
                          </td>
                          <td>{formatCurrency(item.VALOR_TOTAL)}</td>
                          <td>
                            <span
                              className={`badge bg-${getStatusBadge(
                                item.STATUS
                              )}`}
                            >
                              {getStatusText(item.STATUS)}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Nova Transferência Tab */}
      {activeTab === "lancamento" && (
        <div className="row">
          <div className="col-md-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-primary text-white">
                <h6 className="card-title mb-0">
                  🔄 Nova Transferência entre Orçamentos
                </h6>
              </div>
              <div className="card-body">
                <div className="row">
                  {/* ORIGEM */}
                  <div className="col-md-6">
                    <div className="border-end pe-3">
                      <h6 className="text-danger">
                        📤 ORIGEM (De onde sai a verba)
                      </h6>

                      <div className="mb-3">
                        <label className="form-label">
                          Centro de Custo Origem
                        </label>
                        <select
                          className="form-select"
                          value={transferencia.origemCentroCusto}
                          onChange={(e) => {
                            setTransferencia({
                              ...transferencia,
                              origemCentroCusto: e.target.value,
                              // ✅ LIMPAR NATUREZA E ORÇAMENTO QUANDO MUDAR CENTRO DE CUSTO
                              origemNatureza: "",
                              origemIdOrcto: "",
                            });

                            // ✅ CARREGAR NATUREZAS PARA O NOVO CENTRO DE CUSTO
                            if (e.target.value) {
                              carregarNaturezasOrigem(e.target.value);
                            } else {
                              setNaturezasOrigem([]);
                            }

                            // ✅ LIMPAR DADOS DO ORÇAMENTO ORIGEM
                            setDadosOrcamentoOrigem(null);
                          }}
                        >
                          <option value="">
                            Selecione o centro de custo origem
                          </option>
                          {centrosCusto.map((cc) => (
                            <option key={cc.CODCCUSTO} value={cc.CODCCUSTO}>
                              {cc.CODCCUSTO} - {cc.CENTROCUSTO}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">
                          Natureza Orçamentária Origem
                        </label>
                        <select
                          className="form-select"
                          value={transferencia.origemNatureza}
                          onChange={(e) => {
                            setTransferencia({
                              ...transferencia,
                              origemNatureza: e.target.value,
                              // ✅ LIMPAR IDORCTO - SERÁ PREENCHIDO AUTOMATICAMENTE PELO useEffect
                              origemIdOrcto: "",
                            });

                            // ✅ LIMPAR DADOS DO ORÇAMENTO ORIGEM
                            setDadosOrcamentoOrigem(null);
                          }}
                          disabled={!transferencia.origemCentroCusto}
                        >
                          <option value="">
                            {transferencia.origemCentroCusto
                              ? "Selecione a natureza origem"
                              : "Primeiro selecione o centro de custo"}
                          </option>
                          {naturezasOrigem.map((nat) => (
                            <option
                              key={nat.CODTBORCAMENTO}
                              value={nat.CODTBORCAMENTO}
                            >
                              {nat.CODTBORCAMENTO} - {nat.NATUREZA}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">
                          ID Orçamento Origem
                          {loading &&
                            transferencia.origemCentroCusto &&
                            transferencia.origemNatureza && (
                              <span className="text-muted ms-2">
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                ></span>{" "}
                                Buscando...
                              </span>
                            )}
                        </label>
                        <input
                          type="text"
                          className="form-control bg-light"
                          placeholder={
                            transferencia.origemCentroCusto &&
                            transferencia.origemNatureza
                              ? "Carregando ID do orçamento..."
                              : "Selecione centro de custo e natureza"
                          }
                          value={transferencia.origemIdOrcto}
                          readOnly // ✅ CAMPO SOMENTE LEITURA
                          style={{
                            backgroundColor: "#f8f9fa",
                            cursor: "not-allowed",
                          }}
                        />
                        {transferencia.origemCentroCusto &&
                          transferencia.origemNatureza &&
                          !transferencia.origemIdOrcto &&
                          !loading && (
                            <div className="form-text text-warning">
                              ⚠️ Nenhum orçamento encontrado para esta
                              combinação
                            </div>
                          )}
                        {transferencia.origemIdOrcto && (
                          <div className="form-text text-success">
                            ✅ Orçamento localizado automaticamente
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* DESTINO */}
                  <div className="col-md-6">
                    <div className="ps-3">
                      <h6 className="text-success">
                        📥 DESTINO (Para onde vai a verba)
                      </h6>

                      <div className="mb-3">
                        <label className="form-label">
                          Centro de Custo Destino
                        </label>
                        <select
                          className="form-select"
                          value={transferencia.destinoCentroCusto}
                          onChange={(e) => {
                            setTransferencia({
                              ...transferencia,
                              destinoCentroCusto: e.target.value,
                              // ✅ LIMPAR NATUREZA E ORÇAMENTO QUANDO MUDAR CENTRO DE CUSTO
                              destinoNatureza: "",
                              destinoIdOrcto: "",
                            });

                            // ✅ CARREGAR NATUREZAS PARA O NOVO CENTRO DE CUSTO
                            if (e.target.value) {
                              carregarNaturezasDestino(e.target.value);
                            } else {
                              setNaturezasDestino([]);
                            }

                            // ✅ LIMPAR DADOS DO ORÇAMENTO DESTINO
                            setDadosOrcamentoDestino(null);
                          }}
                        >
                          <option value="">
                            Selecione o centro de custo destino
                          </option>
                          {centrosCusto.map((cc) => (
                            <option key={cc.CODCCUSTO} value={cc.CODCCUSTO}>
                              {cc.CODCCUSTO} - {cc.CENTROCUSTO}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">
                          Natureza Orçamentária Destino
                        </label>
                        <select
                          className="form-select"
                          value={transferencia.destinoNatureza}
                          onChange={(e) => {
                            setTransferencia({
                              ...transferencia,
                              destinoNatureza: e.target.value,
                              // ✅ LIMPAR IDORCTO - SERÁ PREENCHIDO AUTOMATICAMENTE PELO useEffect
                              destinoIdOrcto: "",
                            });

                            // ✅ LIMPAR DADOS DO ORÇAMENTO DESTINO
                            setDadosOrcamentoDestino(null);
                          }}
                          disabled={!transferencia.destinoCentroCusto}
                        >
                          <option value="">
                            {transferencia.destinoCentroCusto
                              ? "Selecione a natureza destino"
                              : "Primeiro selecione o centro de custo"}
                          </option>
                          {naturezasDestino.map((nat) => (
                            <option
                              key={nat.CODTBORCAMENTO}
                              value={nat.CODTBORCAMENTO}
                            >
                              {nat.CODTBORCAMENTO} - {nat.NATUREZA}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">
                          ID Orçamento Destino
                          {loading &&
                            transferencia.destinoCentroCusto &&
                            transferencia.destinoNatureza && (
                              <span className="text-muted ms-2">
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                ></span>{" "}
                                Buscando...
                              </span>
                            )}
                        </label>
                        <input
                          type="text"
                          className="form-control bg-light"
                          placeholder={
                            transferencia.destinoCentroCusto &&
                            transferencia.destinoNatureza
                              ? "Carregando ID do orçamento..."
                              : "Selecione centro de custo e natureza"
                          }
                          value={transferencia.destinoIdOrcto}
                          readOnly // ✅ CAMPO SOMENTE LEITURA
                          style={{
                            backgroundColor: "#f8f9fa",
                            cursor: "not-allowed",
                          }}
                        />
                        {transferencia.destinoCentroCusto &&
                          transferencia.destinoNatureza &&
                          !transferencia.destinoIdOrcto &&
                          !loading && (
                            <div className="form-text text-warning">
                              ⚠️ Nenhum orçamento encontrado para esta
                              combinação
                            </div>
                          )}
                        {transferencia.destinoIdOrcto && (
                          <div className="form-text text-success">
                            ✅ Orçamento localizado automaticamente
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <hr />

                {/* DADOS GERAIS */}
                <div className="row">
                  <div className="col-md-4">
                    <label className="form-label fw-bold">
                      Valor a Transferir (R$)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      placeholder="0,00"
                      value={transferencia.valorTransferido}
                      onChange={(e) =>
                        setTransferencia({
                          ...transferencia,
                          valorTransferido: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div className="col-md-8">
                    <label className="form-label fw-bold">
                      Motivo da Transferência
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Descreva brevemente o motivo..."
                      value={transferencia.motivo}
                      onChange={(e) =>
                        setTransferencia({
                          ...transferencia,
                          motivo: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <label className="form-label">Observações Gerais</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      placeholder="Observações adicionais sobre a transferência..."
                      value={transferencia.observacoes}
                      onChange={(e) =>
                        setTransferencia({
                          ...transferencia,
                          observacoes: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">
                      Justificativa para o Destino
                    </label>
                    <textarea
                      className="form-control"
                      rows="3"
                      placeholder="Justifique a necessidade desta verba no destino..."
                      value={transferencia.justificativaDestino}
                      onChange={(e) =>
                        setTransferencia({
                          ...transferencia,
                          justificativaDestino: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                {/* ✅ SEÇÃO DE CÁLCULO DE SALDOS - CORRIGIDA COM CÁLCULO MANUAL */}
                {(dadosOrcamentoOrigem || dadosOrcamentoDestino) && (
                  <>
                    <hr />
                    <div className="row">
                      <div className="col-12">
                        <h6 className="text-primary mb-3">
                          📊 Simulação de Saldos Após Transferência
                        </h6>
                      </div>
                    </div>

                    <div className="row">
                      {/* CÁLCULOS ORIGEM - CORRIGIDO */}
                      {dadosOrcamentoOrigem && (
                        <div className="col-md-6">
                          <div className="card border-danger">
                            <div className="card-header bg-danger text-white">
                              <h6 className="card-title mb-0">
                                📤 Origem - Saldos
                              </h6>
                            </div>
                            <div className="card-body">
                              <div className="row text-center">
                                <div className="col-4">
                                  <div className="border-end">
                                    <h6 className="text-muted mb-1">
                                      Saldo Atual
                                    </h6>
                                    <h5 className="text-info mb-0">
                                      {/* ✅ CALCULAR SALDO MANUALMENTE: ORÇADO - REALIZADO */}
                                      {formatCurrency(
                                        dadosOrcamentoOrigem.VALOR_ORCADO -
                                          dadosOrcamentoOrigem.VALOR_REALIZADO
                                      )}
                                    </h5>
                                  </div>
                                </div>
                                <div className="col-4">
                                  <div className="border-end">
                                    <h6 className="text-muted mb-1">
                                      Valor a Sair
                                    </h6>
                                    <h5 className="text-warning mb-0">
                                      {transferencia.valorTransferido
                                        ? `-${formatCurrency(
                                            parseFloat(
                                              transferencia.valorTransferido
                                            )
                                          )}`
                                        : "R$ 0,00"}
                                    </h5>
                                  </div>
                                </div>
                                <div className="col-4">
                                  <h6 className="text-muted mb-1">
                                    Saldo Final
                                  </h6>
                                  {transferencia.valorTransferido ? (
                                    <h5
                                      className={`mb-0 ${
                                        dadosOrcamentoOrigem.VALOR_ORCADO -
                                          dadosOrcamentoOrigem.VALOR_REALIZADO -
                                          parseFloat(
                                            transferencia.valorTransferido
                                          ) <
                                        0
                                          ? "text-danger"
                                          : "text-success"
                                      }`}
                                    >
                                      {/* ✅ USAR SALDO CALCULADO NO SALDO FINAL */}
                                      {formatCurrency(
                                        dadosOrcamentoOrigem.VALOR_ORCADO -
                                          dadosOrcamentoOrigem.VALOR_REALIZADO -
                                          parseFloat(
                                            transferencia.valorTransferido
                                          )
                                      )}
                                    </h5>
                                  ) : (
                                    <h5 className="text-muted mb-0">-</h5>
                                  )}
                                </div>
                              </div>

                              {/* ALERTA DE SALDO INSUFICIENTE - USANDO SALDO CALCULADO */}
                              {transferencia.valorTransferido &&
                                parseFloat(transferencia.valorTransferido) >
                                  dadosOrcamentoOrigem.VALOR_ORCADO -
                                    dadosOrcamentoOrigem.VALOR_REALIZADO && (
                                  <div
                                    className="alert alert-danger mt-3 mb-0"
                                    role="alert"
                                  >
                                    <strong>⚠️ Saldo Insuficiente!</strong>
                                    <br />
                                    Faltam:{" "}
                                    {formatCurrency(
                                      parseFloat(
                                        transferencia.valorTransferido
                                      ) -
                                        (dadosOrcamentoOrigem.VALOR_ORCADO -
                                          dadosOrcamentoOrigem.VALOR_REALIZADO)
                                    )}
                                  </div>
                                )}

                              {/* INFORMAÇÕES ADICIONAIS ORIGEM */}
                              <div className="mt-3">
                                <small className="text-muted">
                                  <strong>Centro:</strong>{" "}
                                  {dadosOrcamentoOrigem.CENTROCUSTO}
                                  <br />
                                  <strong>Natureza:</strong>{" "}
                                  {dadosOrcamentoOrigem.NATUREZA}
                                  <br />
                                  <strong>Orçado:</strong>{" "}
                                  {formatCurrency(
                                    dadosOrcamentoOrigem.VALOR_ORCADO
                                  )}
                                  <br />
                                  <strong>Realizado:</strong>{" "}
                                  {formatCurrency(
                                    dadosOrcamentoOrigem.VALOR_REALIZADO
                                  )}
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* CÁLCULOS DESTINO - MANTIDO COMO ESTAVA */}
                      {dadosOrcamentoDestino && (
                        <div className="col-md-6">
                          <div className="card border-success">
                            <div className="card-header bg-success text-white">
                              <h6 className="card-title mb-0">
                                📥 Destino - Saldos
                              </h6>
                            </div>
                            <div className="card-body">
                              <div className="row text-center">
                                <div className="col-4">
                                  <div className="border-end">
                                    <h6 className="text-muted mb-1">
                                      Saldo Atual
                                    </h6>
                                    <h5 className="text-info mb-0">
                                      {formatCurrency(
                                        dadosOrcamentoDestino.VALOR_ORCADO
                                      )}
                                    </h5>
                                  </div>
                                </div>
                                <div className="col-4">
                                  <div className="border-end">
                                    <h6 className="text-muted mb-1">
                                      Valor a Receber
                                    </h6>
                                    <h5 className="text-success mb-0">
                                      {transferencia.valorTransferido
                                        ? `+${formatCurrency(
                                            parseFloat(
                                              transferencia.valorTransferido
                                            )
                                          )}`
                                        : "R$ 0,00"}
                                    </h5>
                                  </div>
                                </div>
                                <div className="col-4">
                                  <h6 className="text-muted mb-1">
                                    Saldo Final
                                  </h6>
                                  {transferencia.valorTransferido ? (
                                    <h5 className="text-success mb-0">
                                      {formatCurrency(
                                        dadosOrcamentoDestino.VALOR_ORCADO +
                                          parseFloat(
                                            transferencia.valorTransferido
                                          )
                                      )}
                                    </h5>
                                  ) : (
                                    <h5 className="text-muted mb-0">-</h5>
                                  )}
                                </div>
                              </div>

                              {/* INFORMAÇÕES ADICIONAIS DESTINO */}
                              <div className="mt-3">
                                <small className="text-muted">
                                  <strong>Centro:</strong>{" "}
                                  {dadosOrcamentoDestino.CENTROCUSTO}
                                  <br />
                                  <strong>Natureza:</strong>{" "}
                                  {dadosOrcamentoDestino.NATUREZA}
                                  <br />
                                  <strong>Orçado:</strong>{" "}
                                  {formatCurrency(
                                    dadosOrcamentoDestino.VALOR_ORCADO
                                  )}
                                  <br />
                                  <strong>Realizado:</strong>{" "}
                                  {formatCurrency(
                                    dadosOrcamentoDestino.VALOR_REALIZADO
                                  )}
                                  <br />
                                  <strong>Saldo Disponível:</strong>{" "}
                                  {formatCurrency(dadosOrcamentoDestino.SALDO)}
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* RESUMO DA OPERAÇÃO - CORRIGIDO COM SALDO CALCULADO */}
                    {dadosOrcamentoOrigem &&
                      dadosOrcamentoDestino &&
                      transferencia.valorTransferido && (
                        <div className="row mt-3">
                          <div className="col-12">
                            <div className="card border-primary">
                              <div className="card-header bg-primary text-white">
                                <h6 className="card-title mb-0">
                                  📋 Resumo da Operação
                                </h6>
                              </div>
                              <div className="card-body">
                                <div className="row text-center">
                                  <div className="col-md-3">
                                    <h6 className="text-muted">
                                      Valor da Transferência
                                    </h6>
                                    <h4 className="text-primary">
                                      {formatCurrency(
                                        parseFloat(
                                          transferencia.valorTransferido
                                        )
                                      )}
                                    </h4>
                                  </div>
                                  <div className="col-md-3">
                                    <h6 className="text-muted">
                                      Impacto na Origem
                                    </h6>
                                    <h4 className="text-danger">
                                      {/* ✅ USAR SALDO CALCULADO NO RESUMO */}
                                      {formatCurrency(
                                        dadosOrcamentoOrigem.VALOR_ORCADO -
                                          dadosOrcamentoOrigem.VALOR_REALIZADO
                                      )}{" "}
                                      →{" "}
                                      {formatCurrency(
                                        dadosOrcamentoOrigem.VALOR_ORCADO -
                                          dadosOrcamentoOrigem.VALOR_REALIZADO -
                                          parseFloat(
                                            transferencia.valorTransferido
                                          )
                                      )}
                                    </h4>
                                  </div>
                                  <div className="col-md-3">
                                    <h6 className="text-muted">
                                      Impacto no Destino
                                    </h6>
                                    <h4 className="text-success">
                                      {formatCurrency(
                                        dadosOrcamentoDestino.VALOR_ORCADO
                                      )}{" "}
                                      →{" "}
                                      {formatCurrency(
                                        dadosOrcamentoDestino.VALOR_ORCADO +
                                          parseFloat(
                                            transferencia.valorTransferido
                                          )
                                      )}
                                    </h4>
                                  </div>
                                  <div className="col-md-3">
                                    <h6 className="text-muted">
                                      Status da Operação
                                    </h6>
                                    {/* ✅ USAR SALDO CALCULADO NA VALIDAÇÃO */}
                                    {parseFloat(
                                      transferencia.valorTransferido
                                    ) >
                                    dadosOrcamentoOrigem.VALOR_ORCADO -
                                      dadosOrcamentoOrigem.VALOR_REALIZADO ? (
                                      <h4 className="text-danger">
                                        ❌ Inválida
                                      </h4>
                                    ) : (
                                      <h4 className="text-success">
                                        ✅ Válida
                                      </h4>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                  </>
                )}

                <div className="d-grid mt-4">
                  <button
                    className="btn btn-primary btn-lg"
                    onClick={criarTransferencia}
                    disabled={!canSubmitTransferencia()}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                        Processando...
                      </>
                    ) : (
                      "🔄 Criar Transferência"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Aguardando Aprovação Tab */}
      {activeTab === "aguardando" && (
        <div className="row">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-warning text-dark">
                <h6 className="card-title mb-0">
                  ⏳ Transferências Aguardando Aprovação
                </h6>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Filial</th>
                        <th>Número</th>
                        <th>Data</th>
                        <th>Solicitante</th>
                        <th>Transferência</th>
                        <th>Valor</th>
                        <th>Motivo</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transferenciasGlobal
                        .filter((item) => item.STATUS === "PENDENTE")
                        .map((item) => (
                          <tr key={item.IDTRANSFERENCIA}>
                            <td>{item.NOMEFANTASIA}</td>
                            <td>
                              <code>{item.NUMERO_TRANSFERENCIA}</code>
                            </td>
                            <td>
                              {new Date(
                                item.DATA_SOLICITACAO
                              ).toLocaleDateString("pt-BR")}
                            </td>
                            <td>{item.CRIADO_POR}</td>
                            <td>
                              <div>
                                <strong>De:</strong> {item.CENTROCUSTO_ORIGEM}
                                <br />
                                <small className="text-muted">
                                  {item.NATUREZA_ORIGEM}
                                </small>
                              </div>
                              <div className="mt-1">
                                <strong>Para:</strong>{" "}
                                {item.CENTROCUSTO_DESTINO}
                                <br />
                                <small className="text-muted">
                                  {item.NATUREZA_DESTINO}
                                </small>
                              </div>
                            </td>
                            <td>{formatCurrency(item.VALOR_TOTAL)}</td>
                            <td>
                              <small title={item.MOTIVO}>
                                {item.MOTIVO.length > 50
                                  ? `${item.MOTIVO.substring(0, 50)}...`
                                  : item.MOTIVO}
                              </small>
                            </td>
                            <td>
                              <div className="btn-group-vertical" role="group">
                                <button
                                  className="btn btn-sm btn-success"
                                  onClick={() => confirmarAprovacao(item)}
                                  disabled={loading}
                                  title={`Aprovar transferência ${item.NUMERO_TRANSFERENCIA}`}
                                >
                                  {loading ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm me-1"
                                        role="status"
                                      ></span>
                                      Processando...
                                    </>
                                  ) : (
                                    "✅ Aprovar"
                                  )}
                                </button>
                                <button
                                  className="btn btn-sm btn-danger mt-1"
                                  onClick={() => confirmarReprovacao(item)}
                                  disabled={loading}
                                  title={`Reprovar transferência ${item.NUMERO_TRANSFERENCIA}`}
                                >
                                  {loading ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm me-1"
                                        role="status"
                                      ></span>
                                      Processando...
                                    </>
                                  ) : (
                                    "❌ Reprovar"
                                  )}
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Aprovadas Tab */}
      {activeTab === "aprovacao" && (
        <div className="row">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-success text-white">
                <h6 className="card-title mb-0">✅ Transferências Aprovadas</h6>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Número</th>
                        <th>Data Solicitação</th>
                        <th>Data Aprovação</th>
                        <th>Aprovado Por</th>
                        <th>Transferência</th>
                        <th>Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transferencias
                        .filter((item) => item.STATUS === "EFETIVADA")
                        .map((item) => (
                          <tr key={item.IDTRANSFERENCIA}>
                            <td>
                              <code>{item.NUMERO_TRANSFERENCIA}</code>
                            </td>
                            <td>
                              {new Date(
                                item.DATA_SOLICITACAO
                              ).toLocaleDateString("pt-BR")}
                            </td>
                            <td>
                              {item.DATA_APROVACAO
                                ? new Date(
                                    item.DATA_APROVACAO
                                  ).toLocaleDateString("pt-BR")
                                : "-"}
                            </td>
                            <td>{item.APROVADO_POR || "-"}</td>
                            <td>
                              <div>
                                <strong>De:</strong> {item.CENTROCUSTO_ORIGEM}
                                <br />
                                <small className="text-muted">
                                  {item.NATUREZA_ORIGEM}
                                </small>
                              </div>
                              <div className="mt-1">
                                <strong>Para:</strong>{" "}
                                {item.CENTROCUSTO_DESTINO}
                                <br />
                                <small className="text-muted">
                                  {item.NATUREZA_DESTINO}
                                </small>
                              </div>
                            </td>
                            <td>{formatCurrency(item.VALOR_TOTAL)}</td>
                            {/*<td>
                              <button
                                className="btn btn-sm btn-primary"
                                onClick={() => confirmarEfetivacao(item)}
                                disabled={loading}
                                title={`Efetivar transferência ${item.NUMERO_TRANSFERENCIA}`}
                              >
                                {loading ? (
                                  <>
                                    <span
                                      className="spinner-border spinner-border-sm me-1"
                                      role="status"
                                    ></span>
                                    Efetivando...
                                  </>
                                ) : (
                                  "🔄 Efetivar"
                                )}
                              </button>
                            </td> */}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Rejeitadas Tab */}
      {activeTab === "reprovacao" && (
        <div className="row">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-danger text-white">
                <h6 className="card-title mb-0">
                  ❌ Transferências Rejeitadas
                </h6>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Número</th>
                        <th>Data</th>
                        <th>Solicitante</th>
                        <th>Transferência</th>
                        <th>Valor</th>
                        <th>Motivo Rejeição</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transferencias
                        .filter((item) => item.STATUS === "REJEITADA")
                        .map((item) => (
                          <tr key={item.IDTRANSFERENCIA}>
                            <td>
                              <code>{item.NUMERO_TRANSFERENCIA}</code>
                            </td>
                            <td>
                              {new Date(
                                item.DATA_SOLICITACAO
                              ).toLocaleDateString("pt-BR")}
                            </td>
                            <td>{item.CRIADO_POR}</td>
                            <td>
                              <div>
                                <strong>De:</strong> {item.CENTROCUSTO_ORIGEM}
                                <br />
                                <small className="text-muted">
                                  {item.NATUREZA_ORIGEM}
                                </small>
                              </div>
                              <div className="mt-1">
                                <strong>Para:</strong>{" "}
                                {item.CENTROCUSTO_DESTINO}
                                <br />
                                <small className="text-muted">
                                  {item.NATUREZA_DESTINO}
                                </small>
                              </div>
                            </td>
                            <td>{formatCurrency(item.VALOR_TOTAL)}</td>
                            <td>
                              <span className="badge bg-danger">Rejeitada</span>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Histórico Tab */}
      {activeTab === "historico" && (
        <div className="row">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-dark text-white">
                <h6 className="card-title mb-0">
                  📈 Histórico Completo de Transferências
                </h6>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Número</th>
                        <th>Data</th>
                        <th>Solicitante</th>
                        <th>Transferência</th>
                        <th>Valor</th>
                        <th>Status</th>
                        <th>Data Efetivação</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transferencias
                        .sort(
                          (a, b) =>
                            new Date(b.DATA_SOLICITACAO) -
                            new Date(a.DATA_SOLICITACAO)
                        )
                        .map((item) => (
                          <tr key={item.IDTRANSFERENCIA}>
                            <td>
                              <code>{item.NUMERO_TRANSFERENCIA}</code>
                            </td>
                            <td>
                              {new Date(
                                item.DATA_SOLICITACAO
                              ).toLocaleDateString("pt-BR")}
                            </td>
                            <td>{item.CRIADO_POR}</td>
                            <td>
                              <div>
                                <strong>De:</strong> {item.CENTROCUSTO_ORIGEM}
                                <br />
                                <small className="text-muted">
                                  {item.NATUREZA_ORIGEM}
                                </small>
                              </div>
                              <div className="mt-1">
                                <strong>Para:</strong>{" "}
                                {item.CENTROCUSTO_DESTINO}
                                <br />
                                <small className="text-muted">
                                  {item.NATUREZA_DESTINO}
                                </small>
                              </div>
                            </td>
                            <td>{formatCurrency(item.VALOR_TOTAL)}</td>
                            <td>
                              <span
                                className={`badge bg-${getStatusBadge(
                                  item.STATUS
                                )}`}
                              >
                                {getStatusText(item.STATUS)}
                              </span>
                            </td>
                            <td>
                              {item.DATA_EFETIVACAO
                                ? new Date(
                                    item.DATA_EFETIVACAO
                                  ).toLocaleDateString("pt-BR")
                                : "-"}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SistemaTransferenciaVerba;
